import Vue from 'vue'
import EditableDiv from './index.vue'

Vue.component('EditableDiv', EditableDiv)



// WEBPACK FOOTER //
// ./src/components/editable-div/index.js